import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Legal.css';

export default function Datenschutz() {
    return (
        <div className="legal-page">
            <div className="legal-content">
                <Link to="/" className="legal-back">‹ Zurück</Link>
                <h1>Datenschutzerklärung</h1>

                <h2>1. Verantwortlicher</h2>
                <p>
                    Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
                    TechCrafters GmbH<br />
                    Schulstrasse 12, 78652 Deisslingen<br />
                    E-Mail: info@techcrafters.de
                </p>

                <h2>2. Allgemeines zur Datenverarbeitung</h2>
                <p>
                    Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
                    Bereitstellung einer funktionsfähigen Anwendung sowie unserer Inhalte und Leistungen
                    erforderlich ist. Rechtsgrundlage ist Art. 6 Abs. 1 DSGVO (Vertragserfüllung, berechtigtes
                    Interesse bzw. Einwilligung).
                </p>

                <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
                <p>
                    Bei der Nutzung der Anwendung verarbeiten wir insbesondere: Name, E-Mail-Adresse,
                    Anmeldedaten sowie die von Ihnen erfassten Arbeits- und Projektzeiten. Diese Daten werden
                    zur Bereitstellung der Zeiterfassungs- und Abrechnungsfunktionen verwendet und für die
                    Dauer der Vertragsbeziehung bzw. gemäß gesetzlicher Aufbewahrungsfristen gespeichert.
                </p>

                <h2>4. Server-Logfiles</h2>
                <p>
                    Beim Aufruf der Website werden automatisch Informationen (z. B. IP-Adresse, Datum und
                    Uhrzeit, aufgerufene Seite) in Server-Logfiles gespeichert. Dies dient der Sicherheit und
                    dem technisch fehlerfreien Betrieb. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
                </p>

                <h2>5. Cookies</h2>
                <p>
                    Wir verwenden technisch notwendige Cookies bzw. lokalen Speicher, um die Anmeldung und
                    grundlegende Funktionen bereitzustellen. Diese sind für den Betrieb erforderlich und
                    bedürfen keiner Einwilligung.
                </p>

                <h2>6. Ihre Rechte</h2>
                <p>Sie haben nach der DSGVO das Recht auf:</p>
                <ul>
                    <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
                    <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                    <li>Löschung (Art. 17 DSGVO)</li>
                    <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                    <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                    <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                    <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
                </ul>

                <h2>7. SSL-/TLS-Verschlüsselung</h2>
                <p>
                    Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte
                    Verbindung erkennen Sie an „https://" in der Adresszeile Ihres Browsers.
                </p>

                <h2>8. Kontakt</h2>
                <p>
                    Bei Fragen zum Datenschutz erreichen Sie uns unter: [datenschutz@scalewisp.com]
                </p>

                <h2>9. Änderungen dieser Datenschutzerklärung</h2>
                <p>
                    Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
                    rechtlichen Anforderungen entspricht. Es gilt die jeweils aktuelle, hier veröffentlichte
                    Fassung.
                </p>
            </div>
        </div>
    );
}
